(function (ws) {
    'use strict';

    ws.views.contactqueryPageForms = ws.views.form.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'contact',
        GTM_EVENT_ACTION: 'submit_form',

        mainError: '.error-message',

        /**
         * Extend generic form events
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            'change .country-select': 'onCountryChange',
            'input #accountNumber': 'onChangeAddressId'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$emailField = this.$('input.email');
            this.$country = this.$('#country');
            this.$confirmTxt = this.$('.confirmTxt');
            this.$mobileNumber = this.$('#j_mobileNo');
            this.$phoneNumberCountryCode = this.$('#countryCode');
            this.$mobileNumberCountryCode = this.$('select[name="mobileNoCountryCode"]');
            this.selectQuestionTypeValues = _.template($('#select-dropdown').html());
            this.selectQuestionTypeDropdownContainer = this.$('.language-dropdown-container');
            this.$phoneNo = $('#j_phoneNo');
            this.error = false;
            this.accountNumber = this.$('input#accountNumber');
            this.accountNumber.attr('maxlength', 10);
            this.updateQuestionType();
        },

        /**
         * Actions On Country Change
         * @param {Event} e
         */
        onCountryChange(e) {
            this.setSalesOrg();
            this.updatePhoneCountryCode();
            this.updateMobileCountryCode();
            this.updateQuestionType();
        },

        /**
         * Set Current Sales Org
         */
        setSalesOrg() {
            this.salesOrg = this.$country.find('option:selected').data('salesorg');
        },

        /**
         * Populating the Questiontype dropdown based on the salesorg selection
         */
        updateQuestionType() {
            const saleOrg = $('.country-select').find('option:selected').data('salesorg');
            if (saleOrg) {
                const url = 'contactus/questionTypes/' + saleOrg;
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: function (data) {
                        this.selectQuestionTypeDropdownContainer.html(this.selectQuestionTypeValues({data:data}));
                    }.bind(this)
                });
            }
        },

        /**
         * Updates the phone country code based on the selected country
         * if the phone number has not been entered yet.
         */
        updatePhoneCountryCode() {
            const isPhoneNumberModified = this.$phoneNo.val().trim() !== '';
            const isPhoneNumberCountryCodeModified = this.$phoneNumberCountryCode.val().trim() !== '';

            if (!isPhoneNumberModified || (isPhoneNumberModified && !isPhoneNumberCountryCodeModified)) {
                this.$phoneNumberCountryCode
                    .val(this.$country.find('option:selected').data('countryCode'))
                    .trigger('change');
                this.removeEmptyOptionFromDropdown();
            }
        },

        /**
         * Updates the country code based on the selected country
         * if the Mobile number has not been entered yet.
         */
        updateMobileCountryCode() {
            const isMobileNumberModified = this.$mobileNumber.val().trim() !== '';
            const isMobileNumberCountryCodeModified = this.$mobileNumberCountryCode.val().trim() !== '';

            if (!isMobileNumberModified || (isMobileNumberModified && !isMobileNumberCountryCodeModified)) {
                this.$mobileNumberCountryCode
                    .val(this.$country.find('option:selected').data('countryCode'))
                    .trigger('change');
                this.removeEmptyOptionFromDropdown();
            }
        },

        /**
         * Remove empty option from country code dropdown
         */
        removeEmptyOptionFromDropdown: function () {
            this.$phoneNumberCountryCode.find('option[value=""]').remove();
        },

        /**
         * Checks if the required fields have values for the mandatory elements
         * @param {Object} ev
         */
        checkRequired: function (ev) {
            ev.preventDefault();
            var $mandatoryFields = this.$('input.mandatory,select.mandatory, textarea.mandatory');
            this.error = false;

            _.each($mandatoryFields, function (field) {
                var $field = $(field);
                if ($.trim($field.val()) === '' && $field.closest('fieldset').prop('disabled') !== true && $field.prop('disabled') !== true) {
                    this.error = true;
                    $field.addClass(this.errorClass);
                    $field.nextAll(this.errorMsg).show();
                }
            }.bind(this));

            if (typeof this.additionalValidation === 'function' && this.error === false) {
                this.additionalValidation();
            }

            if (this.error === true) {
                this.hasError();
                _satellite.track('event:user:contractForm:error');
            } else {
                this.validatePopup();
            }
        },

        /**
         * Reset field with error message
         */
        resetField: function(e) {
            var $el = $(e.target);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
            $el.parents('.controls').next('.help-inline').hide();
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkEmail();
            this.checkPhone();
        },

        /**
         * Filters the address ID to only contain numerical values.
         */
        onChangeAddressId() {
            this.filterAddressId();
        },

        /**
         * Filters the address ID to only contain numerical values.
         */
        filterAddressId() {
            const addressId = this.accountNumber.val();

            // Remove non-numerical values from the ID
            this.accountNumber.val(addressId.replace(/\D/g, ''));
        },

        /**
         * Open pop up only when validations are correct
         */
        validatePopup: function () {
            if (this.error === false) {
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
                _satellite.track('event:user:contractForm');
                this.$confirmTxt.text('Please wait...');
                $.ajax({
                    url: 'contactus/sendMail',
                    data: this.$el.serialize(),
                    method: 'POST',
                    /**
                     * On success call modal
                     */
                    success: function (data) {
                        $('#contactForm')[0].reset();
                        if (data.status === true) {
                            this.eventAgg.trigger('comp-contactquery-modal');
                            this.$confirmTxt.text(data.message);
                            this.$phoneNo.parent().find('.custom-required-error-message').hide();
                        } else {
                            this.$phoneNo.addClass('error');
                            this.$phoneNo.parent().find('.custom-required-error-message').text(data.message).show();
                        }
                    }.bind(this)
                });
            }

            return false;
        }
    });
})(westcon);
